import React from 'react';
import "./stylesheet/mobilesheet/projectM.css"
import "./stylesheet/project.css";

const card = [
  {

    id: 0,
    title: "Market Place App",
    background: "url(./media/ecom.png)",
    link:"https:/ecommerce-05.netlify.app/",
    description: "Add product eassily, start selling",
    lang: ["React","Node JS","Express js","MongodB",'FetchApi'],
  
  },
  {

    id: 1,
    title: "Parking Mangement App",
    background: "url(./media/parkma.png)",
    link:"https://parkma.netlify.app/",
    description: "hello this is umang sahu . and this is my first ever project completed  in these days ",
    lang: ["HTML", "CSS", "Javascript", "React"],
   
  
  },{

  id: 2,
  title: "Swiggy Clone",
  background: "url(./media/swclone.png)",
  link:"https://swiggy-clone01.netlify.app/",
  description: "hello this is umang sahu . and this is my first ever project completed  in these days ",
  lang: ["HTML", "CSS", "Javascript", "React"],
 

},
{

  id: 3,
  title: "Keep clone",
  background: "url(./media/keep.png)",
  link:"https://umangsahu.github.io/keep/index.html",

  description: "hello this is umang sahu . and this is my first ever project completed  in these days ",
  lang: ["HTML", "CSS", "Javascript"],

},
{

  id: 4,
  title: "Jokes website",
  background: "url(./media/jokesapi.png)",
  link:"https://jokessitewithapi.netlify.app/",

  description: "hello this is umang sahu . and this is my first ever project completed  in these days ",
  lang: ["HTML", "CSS", "Javascript","restApi"],

},


]




const Project = () => {

  return (
    <>
      <section className="project">
        <div className="heading">
          <span className='mainHeading'>Previos Projects!</span>
          <span className='line'></span>
          <span className='subtext'><span>
            Project is one of the best way to judge anyone  because this is the only way to check that one’s have knowledge or not. here is all of my best project till date. Check Every project . to ensure why i am  right guy for handling  your project</span></span>
        </div>


        <div className="project-component">

          {card.map((elem, index) => {

            return (

              <>
                <div className="card_container" key={"1" + elem.id}>
                  <a target="_blank" href={elem.link}>
                  <div className="card" key={"2" + elem.id} style={{ background: elem.background }
                  } >

                  
                  </div></a>
                  <div className="text " key={"3" + elem.id}>
                      <span className="title" key={"4" + elem.id}>{elem.title}</span>
                      {/* <p className="description" key={elem.id}>{elem.description}</p> */}
                      <span id="tag_box">
                        {elem.lang.map((tag) => {
                          return (
                            <span id='tag'>{tag}</span>
                          )
                        })}
                      </span>

                    </div>

                </div>
              
              </>


            )
          })}
        </div>

      </section>
    </>
  )
}

export default Project